/* EL BUEN VINO — theme interactions */
(function () {
  'use strict';

  /* ---- Scroll reveal ---- */
  const revealEls = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && revealEls.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach((el) => io.observe(el));
  } else {
    revealEls.forEach((el) => el.classList.add('is-visible'));
  }

  /* ---- Header: shrink on scroll + mobile menu ---- */
  const header = document.querySelector('[data-header]');
  if (header) {
    let last = 0;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 20);
      last = y;
    }, { passive: true });

    const toggle = header.querySelector('[data-menu-toggle]');
    const drawer = document.querySelector('[data-mobile-drawer]');
    if (toggle && drawer) {
      const close = () => { drawer.classList.remove('is-open'); toggle.setAttribute('aria-expanded', 'false'); document.body.style.overflow = ''; };
      toggle.addEventListener('click', () => {
        const open = drawer.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.body.style.overflow = open ? 'hidden' : '';
      });
      drawer.querySelectorAll('[data-drawer-close]').forEach((b) => b.addEventListener('click', close));
      drawer.addEventListener('click', (e) => { if (e.target === drawer) close(); });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
    }
  }

  /* ---- Search toggle ---- */
  const searchToggle = document.querySelector('[data-search-toggle]');
  const searchBar = document.querySelector('[data-search-bar]');
  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', () => {
      const open = searchBar.classList.toggle('is-open');
      if (open) { const i = searchBar.querySelector('input'); if (i) i.focus(); }
    });
  }

  /* ---- Club billing toggle (monthly / annual) ---- */
  document.querySelectorAll('[data-billing-toggle]').forEach((wrap) => {
    const buttons = wrap.querySelectorAll('[data-billing]');
    const scope = wrap.closest('[data-club]') || document;
    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        buttons.forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        const mode = btn.getAttribute('data-billing');
        scope.querySelectorAll('[data-price-monthly], [data-price-annual]').forEach((el) => {
          el.hidden = !el.hasAttribute('data-price-' + mode);
        });
      });
    });
  });

  /* ---- Simple FAQ accordion ---- */
  document.querySelectorAll('[data-accordion] > details').forEach((d) => {
    d.addEventListener('toggle', () => {
      if (d.open) {
        d.parentElement.querySelectorAll('details[open]').forEach((o) => { if (o !== d) o.open = false; });
      }
    });
  });

  /* ---- Quantity steppers ---- */
  document.querySelectorAll('[data-qty]').forEach((wrap) => {
    const input = wrap.querySelector('input');
    wrap.querySelectorAll('[data-qty-btn]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const step = btn.getAttribute('data-qty-btn') === 'up' ? 1 : -1;
        const val = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = val;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });
})();
